import styled from "@emotion/styled";
import { Typography, Box, Divider } from "@mui/material";
import { COLOR_GREY_11, COLOR_GREY_13 } from "shared/theme/colors";

export const StyledMenuBarContainer = styled(Box, {
  shouldForwardProp: (props) => props !== "expanded",
})<{ expanded: boolean }>`
  position: relative;
  min-width: ${({ expanded }) => (expanded ? "308px" : "100px")};
  z-index: 5;
`;

export const StyledTitle = styled(Typography)`
  font-weight: 700;
  color: ${COLOR_GREY_13};
  text-transform: uppercase;
  font-variant: all-small-caps;
  &:not(:first-of-type) {
    margin-top: 1.125rem;
  }
  margin-bottom: 2px;
`;

export const StyledDivider = styled(Divider)`
  border-color: ${COLOR_GREY_11};
  margin-top: 11.5px;
  &:not(:first-of-type) {
    margin-top: 29.5px;
  }
  margin-bottom: 13.5px;
`;
